import React from "react";
import { Alert } from "antd";
import { Redirect } from "react-router-dom";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import { withApolloState } from "../util/apollo";

const PermissionError = () => (
    <Query
        fetchPolicy="cache-and-network"
        query={gql`
            query FlowPermissionsQuery {
                permissions {
                    flowAccess
                }
            }
        `}
    >
        {withApolloState(({ data }) => (
            <>
                {data.permissions.flowAccess && <Redirect to="/" />}
                <Alert
                    message="Permission Denied"
                    description="You have no permission to access this page."
                    type="error"
                    showIcon
                />
            </>
        ))}
    </Query>
);

export default PermissionError;
